module.exports = __webpack_public_path__ + "static/media/tex_7910.76616d95.jpeg";